<template>
  <el-card>
      <el-row>
          <el-col :span="12">
            <el-form ref="dataForm" :model="dataForm" :rules="rules">
                <el-form-item label="账户名称" prop="account">
                    <el-input v-model="dataForm.account" placeholder="请输入账户名称" :disabled="isDisable"></el-input>
                </el-form-item>
                <el-form-item label="纳税人识别号" prop="taxpayer_id_number">
                    <el-input v-model="dataForm.taxpayer_id_number" placeholder="请输入纳税人识别号" :disabled="isDisable"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="5" v-model="dataForm.remark" :disabled="isDisable"></el-input>
                </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12"></el-col>
      </el-row>
      <el-row>
          <el-col>
            <el-button @click="goBack">返回</el-button>
            <el-button @click="reset" v-if="pageAction === 'action.edit'">重置</el-button>
            <el-button type="primary" @click="save" v-if="pageAction === 'action.add' || pageAction === 'action.edit'">
              保存
              </el-button>
            <el-button type="primary" @click="saveAndAdd" v-if="pageAction === 'action.add'">
              保存并继续添加
              </el-button>
          </el-col>
      </el-row>
  </el-card>
</template>

<script>
import { fetchSettingCompanyAccount } from "@/api/billing"
import { createSettingCompanyAccount } from "@/api/billing"
import { updateSettingCompanyAccount } from "@/api/billing"
export default {
  name: 'setting-company-account',
  data(){
    return {
      dataForm: {
        account: '' ,
        taxpayer_id_number: '' ,
        remark: '',
        company: null,
        branch_office: null,
      },
      tempDataForm:{},
      rules:{
        account:[
          {required: true, message: '请输入账户名称', trigger: 'blur'}
        ],
        taxpayer_id_number:[
          {required: true, message: '请输入纳税人识别号名称', trigger: 'blur'}
        ],
      },
      pageAction: '',
      company_id: 0,
      id: 0,
      isDisable: false,
    }
  },
  methods: {
    clearDataForm: function(){
      this.dataForm.account = ''
      this.dataForm.taxpayer_id_number = ''
      this.dataForm.remark = ''
    },
    showAddView: function(){
      console.log('showAddView()')
      this.pageAction = 'action.add'
      this.isDisable = false
    },
    showView: function(){
      console.log('showView()')
      this.pageAction = 'action.view'
      this.isDisable = true
      this.getData()
    },
    showEditView: function(){
      console.log('showEditView()')
      this.pageAction = 'action.edit'
      this.isDisable = false
      this.getData()
    },
    goBack: function(){
      this.$router.go(-1)
    },
    reset: function(){
      this.dataForm = Object.assign({}, this.tempDataForm) 
    },
    save: function(){
      if(this.pageAction === 'action.add'){
        this.createData(this.goBack)
      } else if(this.pageAction === 'action.edit'){
        this.updateData(null)
      }
    },
    saveAndAdd: function(){
      this.createData(this.clearDataForm)
    },
    getData: function(){
      fetchSettingCompanyAccount(this.id)
        .then(resp=>{
          this.dataForm.account = resp.account
          this.dataForm.taxpayer_id_number = resp.taxpayer_id_number
          this.dataForm.remark = resp.remark
          this.dataForm.company = resp.company 
          this.dataForm.branch_office = resp.branch_office
          this.tempDataForm = Object.assign({}, this.dataForm) 
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    createData: function(callBack){
      this.$refs.dataForm.validate((valid)=>{
        if(valid){
          this.dataForm.company = this.company_id
          this.dataForm.branch_office = this.branch_office_id
          createSettingCompanyAccount(this.dataForm, this.company_id)
            .then(resp=>{
              this.$message.success('保存公司账号信息成功')
              if (typeof callBack == 'function') {
                callBack()
              }
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    },
    updateData: function(callBack){
      this.$refs.dataForm.validate((valid)=>{
        if(valid){
          updateSettingCompanyAccount(this.dataForm, this.id)
            .then(resp=>{
              this.tempDataForm = Object.assign({}, this.dataForm) 
              this.$message.success('保存公司账号信息成功')
              if(typeof callBack == 'function'){
                callBack()
              }
            }).catch(err=>{
              this.$error_message(err)
            })
        }
      })
    },
  },
  created(){
    if (this.$route.query.company_id === undefined || this.$route.query.company_id === null){
      console.log('missing company_id')      
      this.$router.push('/404')
    }
    this.company_id = this.$route.query.company_id

    if (this.$route.query.branch_office_id === undefined || this.$route.query.branch_office_id === null){
      console.log('missing branch_office_id')
      this.$router.push('/404')
    }
    this.branch_office_id = this.$route.query.branch_office_id

    if (this.$route.name === 'addSettingCompanyAccount'){
      if (!this.$perm(["billing.create_setting_company_account"])) {
        this.$router.push('/401')
      }
      this.showAddView()
      return 
    }

    if (this.$route.query.id === undefined || this.$route.query.id === null){
      this.$router.push('/404')
    }
    this.id = this.$route.query.id

    if (this.$route.name === 'viewSettingCompanyAccount'){
      if (!this.$perm(["billing.view_setting_company_account"])) {
        this.$router.push('/401')
      }
      this.showView()
      return 
    } 

    if (this.$route.name === 'editSettingCompanyAccount'){
      if (!this.$perm(["billing.update_setting_company_account"])) {
        this.$router.push('/401')
      }
      this.showEditView()
      return 
    }

    this.$router.push('/404')
  }
}
</script>